import React from "react";
import PostsList from "../posts-list";

const PostsPage = () => {
  return (
    <div>
      <PostsList />
    </div>
  );
};

export default PostsPage;
